var KonfigurationJSON = {
  importierteKonfiguration: {},
}
if (window.location.hostname == 'localhost') {
  console.log("Localhost Mode")
  KonfigurationJSON.restPath = 'http://localhost:8081/api/'
  KonfigurationJSON.path = 'http://localhost:8081/'
} else {
  console.log("IP/Global Mode")
  KonfigurationJSON.restPath = '/api/'
  KonfigurationJSON.path = '/'
}

export default KonfigurationJSON;

